export default "__VITE_PUBLIC_ASSET__45845bbc__"